import Invoice1Container from "../../../../../Components/Applications/Ecommerce/Invoice/Invoice1/Invoice1Container";

const Invoice1 = () => {
  return <Invoice1Container />;
};

export default Invoice1;
